import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";

export const useStyles = makeStyles(() => ({
    root: {
        display: "none",
        "& .MuiIconButton-root": {
            padding: 0,
            margin: 0,
        },
    },
    moreMenu: {
        maxHeight: "15rem",
        border: globalThis.config.border.medium,
        borderRadius: "0.18rem",
        backgroundColor: globalThis.config.colors.white,
    },
    itemLabel: {
        paddingRight: "16px",
    },
}));

export const ButtonLink = styled.a`
    span {
        text-decoration: none;
        color: ${globalThis.config.colors.black};
    }
    &:hover {
        text-decoration: none;
    }
    button {
        margin-bottom: 0;
    }
    margin-bottom: 0;
    padding: 0.375rem 0.9rem;
`;
